module.exports = "<svg version=\"1.1\" id=\"圖層_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 44.7 44.7\" style=\"enable-background:new 0 0 44.7 44.7;\" xml:space=\"preserve\"><style type=\"text/css\"> .stop-st0{fill:#1BE0A8;} </style><circle id=\"楕円形_2\" class=\"stop-st0\" cx=\"22.3\" cy=\"22.3\" r=\"22.3\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/stop.svg
// module id = m5U/
// module chunks = 1